import styled from 'styled-components';
import { toast } from 'react-toastify';

interface ExternalBrowserPageProps {
  redirecting: boolean;
  openLabel: string;
  onOpen: () => void;
  storeUrl?: string;
  guide: string;
}

/**
 * @description 구조요청 링크를 외부 브라우저(크롬/Safari)로 옮기는 동안, 또는 실패했을 때 보여주는 화면
 */
const ExternalBrowserPage = ({ redirecting, openLabel, onOpen, storeUrl, guide }: ExternalBrowserPageProps) => {
  const toastMessage = (message: string) => <div style={{ fontSize: '1.1rem' }}>{message}</div>;

  const onCopy = async () => {
    const href = window.location.href;
    try {
      await navigator.clipboard.writeText(href);
      toast(toastMessage('링크를 복사했습니다.'), { type: 'success' });
    } catch (error) {
      window.prompt('아래 주소를 복사해 주세요.', href);
    }
  };

  return (
    <ExternalBrowserTemplate>
      <CenterWrap>
        <ImageWrap>
          <img src={process.env.PUBLIC_URL + '/images/img_intro.svg'} alt="intro" />
        </ImageWrap>
        <ImageWrap>
          <img src={process.env.PUBLIC_URL + '/images/img_intro_title.svg'} alt="title" />
        </ImageWrap>
        {redirecting ? (
          <IntroText>브라우저를 여는 중입니다...</IntroText>
        ) : (
          <>
            <IntroText>
              구조요청은 크롬 브라우저에서
              <br />
              정상 동작합니다.
            </IntroText>
            <GuideText>{guide}</GuideText>
          </>
        )}
      </CenterWrap>
      {!redirecting && (
        <ButtonWrap>
          <OpenButton onClick={onOpen}>{openLabel}</OpenButton>
          <CopyButton onClick={onCopy}>{'링크 복사'}</CopyButton>
          {storeUrl && (
            <StoreLink href={storeUrl} target="_blank" rel="noopener noreferrer">
              크롬이 설치되어 있지 않다면 여기서 설치해 주세요.
            </StoreLink>
          )}
        </ButtonWrap>
      )}
    </ExternalBrowserTemplate>
  );
};

const ExternalBrowserTemplate = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #000d3a 48.5%, #cdd2e0 100%);
`;
const CenterWrap = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -30%);
  align-items: center;
  text-align: center;
`;
const ImageWrap = styled.div`
  text-align: center;
  margin-bottom: 10px;
`;
const IntroText = styled.h1`
  width: 280px;
  margin-top: 60px;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  line-height: 35px;
  text-align: center;
`;
const GuideText = styled.p`
  width: 280px;
  margin-top: 16px;
  color: #cdd2e0;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  white-space: pre-line;
`;
const ButtonWrap = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > * {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;
const OpenButton = styled.button`
  width: 300px;
  height: 46px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  background: #0086ff;
  cursor: pointer;
`;
const CopyButton = styled(OpenButton)`
  color: #001b61;
  background: #ffffff;
`;
const StoreLink = styled.a`
  color: #001b61;
  font-size: 13px;
  text-decoration: underline;
`;

export default ExternalBrowserPage;
